import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import {
  onMounted, ref, watch,
} from 'vue';

/*  se não quiser criar um .d.ts global simplesmente declare aqui:   */
declare const google: any;

interface Props {
  lat?: number;
  lng?: number;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'MapPicker',
  props: {
    lat: {},
    lng: {}
  },
  emits: ["update:lat", "update:lng"],
  setup(__props: any, { emit }) {

const props = __props;





const mapRef = ref<HTMLElement | null>(null);
let map: any; // mantemos referência fora do onMounted
let marker: any;

onMounted(() => {
  /* 1. Centro inicial (Taió-SC ou valores passados por prop) */
  const center = {
    lat: props.lat ?? -27.116389,
    lng: props.lng ?? -49.998056,
  };

  /* 2. Cria o mapa */
  map = new google.maps.Map(mapRef.value!, {
    center,
    zoom: 15,
    mapId: 'd92fc09431b9432f9ac1c46a',
  });

  /* 3. Usa AdvancedMarkerElement (já que carregamos libraries=marker) */
  marker = new google.maps.marker.AdvancedMarkerElement({
    position: center,
    map,
    gmpDraggable: true,
    title: 'Arraste para escolher o ponto',
  });

  // eslint-disable-next-line no-undef
  marker.addListener('dragend', (e: google.maps.MapMouseEvent) => {
    if (e.latLng) {
      emit('update:lat', e.latLng.lat());
      emit('update:lng', e.latLng.lng());
    }
  });
});

/* 5. Se lat/lng mudarem externamente, move o marcador */
watch(
  () => [props.lat, props.lng],
  ([lat, lng]) => {
    if (lat != null && lng != null && marker) {
      const pos = { lat, lng };
      marker.position = pos;
      map.setCenter(pos);
    }
  },
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    ref_key: "mapRef",
    ref: mapRef,
    style: {"height":"60vh","width":"100%"}
  }, null, 512))
}
}

})